const style = (theme) => {
  const output = {
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      // minHeight: 500,
      // height: '50vh',
      zIndex: theme.zindex.mainNav,
      pointerEvents: 'none',
    },
    container: {
      height: '100%',
      overflow: 'hidden',
    },
    wrapper: {
      height: '100%',
      background: theme.colors[1],
      transform: 'translateY(-100%)',
      pointerEvents: 'all',
    },
    nav: {
      extend: theme.wrapper,
      paddingTop: (props) => (props.headerHeight) + 40,
      paddingBottom: 80,
      opacity: 0,
    },
    mainVoices: {
      color: theme.colors[0],
      fontSize: 52,
      textTransform: 'uppercase',
      lineHeight: 1,
      '&:not(:last-child)': {
        marginBottom: 35,
      },
      '& a': {
        display: 'block',
        position: 'relative',
        color: theme.colors[0],
        '&:before': {
          content: '""',
          position: 'absolute',
          display: 'block',
          left: -30,
          top: 25,
          // transform: 'translateY(-50%)',
          width: 10,
          height: 10,
          borderRadius: '50%',
          background: theme.colors[3],
          transition: 'all 0.4s ease 1.4s',
          opacity: 0,
        },
      },
      '& button': {
        cursor: 'pointer',
        fontSize: 52,
        textTransform: 'uppercase',
        display: 'block',
        position: 'relative',
        color: theme.colors[0],
        '&:before': {
          content: '""',
          position: 'absolute',
          display: 'block',
          left: -30,
          top: 25,
          // transform: 'translateY(-50%)',
          width: 10,
          height: 10,
          borderRadius: '50%',
          background: theme.colors[3],
          transition: 'all 0.4s ease 1.4s',
          opacity: 0,
        },
      },
    },
    services: {
      marginBottom: 35,
      '& h3': {
        color: theme.colors[0],
        textTransform: 'uppercase',
        lineHeight: 1,
        fontSize: 52,
        marginBottom: 15,
      },
    },
    subheadings: {
      color: theme.colors[0],
      fontSize: 22,
      lineHeight: 1,
      marginLeft: 10,
      '&:not(:last-child)': {
        marginBottom: 10,
      },
      '& a': {
        color: theme.colors[0],
        display: 'block',
        position: 'relative',
        '&:before': {
          content: '""',
          position: 'absolute',
          display: 'block',
          left: -20,
          top: 9,
          // transform: 'translateY(-50%)',
          width: 7,
          height: 7,
          borderRadius: '50%',
          background: theme.colors[3],
          transition: 'all 0.4s ease 1.4s',
          opacity: 0,
        },
      },
    },
    active: {
      pointerEvents: 'none',
      cursor: 'default',
      '&:before': {
        opacity: '1 !important',
      },
    },
    isAnimating: {
      pointerEvents: 'none',
      '& *': {
        pointerEvents: 'none',
      },
    },
    // nav: {
    //   fontWeight: 300,
    //   fontSize: '4.3vw',
    //   '& li': {
    //     lineHeight: 1,
    //     '&:not(:last-child)': {
    //       marginBottom: 15,
    //     },
    //   },
    //   '& span': {
    //     position: 'relative',
    //     fontFamily: theme.fonts[1],
    //     color: theme.colors[3],
    //     lineHeight: 1,
    //     textTransform: 'uppercase',
    //     cursor: 'default',
    //     userSelect: 'none',
    //   },
    //   '& a': {
    //     position: 'relative',
    //     fontFamily: theme.fonts[1],
    //     color: theme.colors[3],
    //     lineHeight: 1,
    //     textTransform: 'uppercase',
    //     userSelect: 'none',
    //     '&:after': {
    //       content: '""',
    //       bottom: 0,
    //       display: 'block',
    //       height: 2,
    //       left: 0,
    //       position: 'absolute',
    //       background: 'currentColor',
    //       transition: 'width 0.4s ease 0s',
    //       width: 0,
    //     },
    //     '@media (hover: hover)': {
    //       '&:hover': {
    //         '&:after': {
    //           width: '100%',
    //         },
    //       },
    //     },
    //   },
    // },
    // mainNav: {
    //   fontSize: '4.3vw',
    // },
    // extraNav: {
    //   fontSize: 30,
    //   '& a': {
    //     '&:after': {
    //       height: 1,
    //     },
    //   },
    //   '& li': {
    //     '&:not(:last-child)': {
    //       marginBottom: 15,
    //     },
    //   },
    // },
    // childNav: {
    //   marginTop: 25,
    //   fontSize: 18,
    //   '& a': {
    //     fontFamily: theme.fonts[0],
    //     textTransform: 'none',
    //     color: theme.colors[4],
    //     fontWeight: 500,
    //     '&:after': {
    //       height: 1,
    //     },
    //   },
    //   '& li': {
    //     marginBottom: 15,
    //   },
    // },
    // visible: {
    //   opacity: 1,
    // },
    // info: {
    //   fontSize: 14,
    //   color: theme.colors[4],
    //   '& > *:not(:last-child)': {
    //     marginBottom: 20,
    //   },
    //   '& a': {
    //     color: theme.colors[4],
    //     extend: theme.link,
    //   },
    // },
    social: {
      position: 'absolute',
      right: 'calc(4.15vw - 30px)',
      bottom: 30,
      '& a': {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
          width: 22,
          height: 22,
          fill: theme.colors[0],
        },
        '& p': {
          fontSize: 12,
          color: theme.colors[0],
          textTransform: 'uppercase',
          marginBottom: 0,
          marginLeft: 10,
        },
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    // root: {
    //   width: '85vw',
    //   height: '85vh',
    // },
    // mainNav: {
    //   fontSize: 50,
    // },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      // height: '40vh',
    },
    nav: {
      height: '100%',
      paddingBottom: 110,
      paddingTop: (props) => (props.headerHeight) + 20,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },
    mainVoices: {
      fontSize: 26,
      '&:not(:last-child)': {
        marginBottom: 20,
      },
      '& a': {
        cursor: 'pointer',
        color: theme.colors[0],
        '&:before': {
          left: -18,
          top: 12,
          width: 6,
          height: 6,
        },
      },
      '& button': {
        fontSize: 26,
        color: theme.colors[0],
        '&:before': {
          left: -18,
          top: 12,
          width: 6,
          height: 6,
        },
      },
    },
    services: {
      marginBottom: 20,
      '& h3': {
        fontSize: 26,
        marginBottom: 12,
      },
    },
    subheadings: {
      fontSize: 18,
      marginLeft: 7,
      '&:not(:last-child)': {
        marginBottom: 8,
      },
      '& a': {
        color: theme.colors[0],
        '&:before': {
          left: -24,
          top: 8,
          width: 6,
          height: 6,
        },
      },
    },
    social: {
      right: 30,
      bottom: 50,
    },
    // root: {
    //   width: '100vw',
    //   height: 'var(--vh-fixed)',
    //   top: 0,
    //   right: 0,
    //   borderRadius: 0,
    //   paddingTop: '15vh',
    // },
    // container: {
    //   height: 'auto',
    // },
    // wrapper: {
    //   '& > *': {
    //     flexBasis: '100%',
    //   },
    // },
    // nav: {
    //   '& li': {
    //     textAlign: 'center',
    //     '&:not(:last-child)': {
    //       marginBottom: 0,
    //     },
    //   },
    //   '& span': {
    //     fontSize: 80,
    //     cursor: 'pointer',
    //   },
    // },
    // mainNav: {
    //   fontSize: 80,
    // },
    // extraNav: {
    //   fontSize: 40,
    //   marginTop: 40,
    //   '& li': {
    //     '&:not(:last-child)': {
    //       marginBottom: 10,
    //     },
    //   },
    // },
    // info: {
    //   marginTop: 40,
    //   textAlign: 'center',
    // },
    // childNav: {
    //   '& li': {
    //     marginBottom: '15px !important',
    //   },
    // },
  }

  return output
}

export default style
